import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { ToastController } from '@ionic/angular';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private toastController: ToastController
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
          // Client-side errors
          errorMessage = `Error: ${error.error.message}`;
        } else {
          // Server-side errors
          errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;

          if (error.status === 401) {
            this.authService.logout();
          } else {
            if (error.error.message) {
              this.toastController
                .create({
                  message: error.error.message,
                  duration: 2000,
                  color: 'danger',
                })
                .then((toast) => toast.present());
            } else {
              this.toastController
                .create({
                  message: error.message,
                  duration: 2000,
                  color: 'danger',
                })
                .then((toast) => toast.present());
            }
          }
        }
        // Display error message or handle it appropriately
        // console.error(errorMessage);
        return throwError(errorMessage);
      })
    );
  }
}
